module.exports = __webpack_public_path__ + "static/media/l_dot_14.ea99448a.png";